module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "el-zoom-in-top"
    }
  }, [_c('div', {
    staticClass: "content-wrapper"
  }, [_c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "box citic-box"
  }, [_c('el-tabs', {
    on: {
      "tab-click": _vm.handleClick
    },
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "正常待发布小程序",
      "name": "0"
    }
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%",
      "margin-bottom": "20px"
    },
    attrs: {
      "data": _vm.uncomfirmList,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "createtime",
      "label": "注册时间",
      "width": "170",
      "fixed": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "factory_qc_name",
      "label": "厂商名称",
      "width": "200",
      "fixed": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "factory_short_name",
      "label": "厂商简称",
      "width": "130"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "小程序二维码",
      "width": "150",
      "prop": "cs_qrcode_url"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-popover', {
          attrs: {
            "placement": "left-start",
            "width": "50px",
            "trigger": "click"
          }
        }, [_c('img', {
          attrs: {
            "src": scope.row.cs_qrcode_url == null ? scope.row.app_qrcode : scope.row.cs_qrcode_url,
            "alt": "",
            "width": "250px"
          }
        }), _vm._v(" "), _c('el-button', {
          attrs: {
            "slot": "reference",
            "type": "primary"
          },
          slot: "reference"
        }, [_vm._v("查看二维码")])], 1)]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "isoriginalfactory",
      "label": "是否推荐",
      "width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.emailaccount !== '' && scope.row.emailaccount !== null) ? _c('el-button', {
          attrs: {
            "type": "primary",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.recommend(scope.row)
            }
          }
        }, [_vm._v(_vm._s(scope.row.isrecommend == 1 ? '取消推荐' : '推荐'))]) : (scope.row.emailaccount == '' || scope.row.emailaccount == null) ? _c('el-button', {
          attrs: {
            "type": "primary",
            "size": "small",
            "disabled": scope.row.emailaccount == '' || scope.row.emailaccount == null
          },
          on: {
            "click": function($event) {
              return _vm.recommend(scope.row)
            }
          }
        }, [_vm._v("无法推荐")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "accountquality_status",
      "label": "账号质量",
      "width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-select', {
          attrs: {
            "placeholder": "请选择",
            "size": "mini"
          },
          on: {
            "change": function($event) {
              return _vm.handlequality(scope.row)
            }
          },
          model: {
            value: (scope.row.accountquality_status),
            callback: function($$v) {
              _vm.$set(scope.row, "accountquality_status", $$v)
            },
            expression: "scope.row.accountquality_status"
          }
        }, _vm._l((_vm.options), function(item) {
          return _c('el-option', {
            key: item.value,
            attrs: {
              "label": item.label,
              "value": item.value
            }
          })
        }), 1)]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "newsnum",
      "label": "发布新闻数",
      "width": "110"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "casenum",
      "label": "发布案例数",
      "width": "110"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "productnum",
      "label": "发布产品数",
      "width": "110"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "productimagenum",
      "label": "产品图片数",
      "width": "110"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "isoriginalfactory",
      "label": "是否已推广",
      "width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.emailaccount !== '' && scope.row.emailaccount !== null) ? _c('el-button', {
          attrs: {
            "type": "primary",
            "size": "small",
            "disabled": scope.row.isextension === '1'
          },
          on: {
            "click": function($event) {
              return _vm.extension(scope.row)
            }
          }
        }, [_vm._v(_vm._s(scope.row.isextension === '1' ? '已推广' : '推广'))]) : (scope.row.emailaccount == '' || scope.row.emailaccount == null) ? _c('el-button', {
          attrs: {
            "type": "primary",
            "size": "small",
            "disabled": scope.row.emailaccount == '' || scope.row.emailaccount == null
          },
          on: {
            "click": function($event) {
              return _vm.extension(scope.row)
            }
          }
        }, [_vm._v("无法推广")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "extensiontime",
      "label": "推广日期",
      "width": "160"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.isextension === '1') ? _c('span', [_vm._v(_vm._s(scope.row.extensiontime))]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "emailaccount",
      "label": "管理员手机号",
      "width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "isExamine",
      "label": "是否提交微信审核",
      "width": "170"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "isExamineSuccess",
      "label": "微信审核是否通过",
      "width": "200"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "isPulish",
      "label": "是否发布小程序",
      "width": "130"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "isendemail",
      "label": "邮件通知",
      "width": "280"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.isExamineSuccess === '否') ? _c('el-button', {
          attrs: {
            "type": "warning",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.send(scope.row)
            }
          }
        }, [_vm._v("微信审核尚未通过，暂不支持发送邮件")]) : (scope.row.isExamineSuccess === '是') ? _c('el-button', {
          attrs: {
            "type": "primary",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.send(scope.row)
            }
          }
        }, [_vm._v("发送邮件")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "isendemail",
      "label": "邮件历史",
      "width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.isendemail === '是') ? _c('el-button', {
          attrs: {
            "type": "info",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.changeStatus(scope.row)
            }
          }
        }, [_vm._v("已发邮件")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "app_nick_name",
      "label": "小程序名称",
      "width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "isoriginalfactory",
      "label": "是否原厂",
      "width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "primary",
            "size": "small",
            "disabled": scope.row.isoriginalfactory !== '否'
          },
          on: {
            "click": function($event) {
              return _vm.confirm(scope.row)
            }
          }
        }, [_vm._v(_vm._s(scope.row.isoriginalfactory == "否" ? '待认证' : '已认证'))])]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "table-list__footer"
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.currentPage.one,
      "page-size": _vm.page_size,
      "layout": "total, prev, pager, next, jumper",
      "total": _vm.totalOne
    },
    on: {
      "current-change": _vm.handlePageChangeOne
    }
  })], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "正常已发布小程序",
      "name": "1"
    }
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%",
      "margin-bottom": "20px"
    },
    attrs: {
      "data": _vm.comfirmList,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "createtime",
      "label": "注册时间",
      "width": "170",
      "fixed": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "factory_qc_name",
      "label": "厂商名称",
      "width": "200",
      "fixed": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "factory_short_name",
      "label": "厂商简称",
      "width": "130"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "小程序二维码",
      "width": "150",
      "prop": "cs_qrcode_url"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-popover', {
          attrs: {
            "placement": "left-start",
            "width": "50px",
            "trigger": "click"
          }
        }, [_c('img', {
          attrs: {
            "src": scope.row.cs_qrcode_url == null ? scope.row.app_qrcode : scope.row.cs_qrcode_url,
            "alt": "",
            "width": "250px"
          }
        }), _vm._v(" "), _c('el-button', {
          attrs: {
            "slot": "reference",
            "type": "primary"
          },
          slot: "reference"
        }, [_vm._v("查看二维码")])], 1)]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "isoriginalfactory",
      "label": "是否推荐",
      "width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "primary",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.recommend(scope.row)
            }
          }
        }, [_vm._v(_vm._s(scope.row.isrecommend == 1 ? '取消推荐' : '推荐'))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "accountquality_status",
      "label": "账号质量",
      "width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-select', {
          attrs: {
            "placeholder": "请选择",
            "size": "mini"
          },
          on: {
            "change": function($event) {
              return _vm.handlequality(scope.row)
            }
          },
          model: {
            value: (scope.row.accountquality_status),
            callback: function($$v) {
              _vm.$set(scope.row, "accountquality_status", $$v)
            },
            expression: "scope.row.accountquality_status"
          }
        }, _vm._l((_vm.options), function(item) {
          return _c('el-option', {
            key: item.value,
            attrs: {
              "label": item.label,
              "value": item.value
            }
          })
        }), 1)]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "newsnum",
      "label": "发布新闻数",
      "width": "110"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "casenum",
      "label": "发布案例数",
      "width": "110"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "productnum",
      "label": "发布产品数",
      "width": "110"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "productimagenum",
      "label": "产品图片数",
      "width": "110"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "isoriginalfactory",
      "label": "是否已推广",
      "width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.emailaccount !== '' && scope.row.emailaccount !== null) ? _c('el-button', {
          attrs: {
            "type": "primary",
            "size": "small",
            "disabled": scope.row.isextension === '1'
          },
          on: {
            "click": function($event) {
              return _vm.extension(scope.row)
            }
          }
        }, [_vm._v(_vm._s(scope.row.isextension === '1' ? '已推广' : '推广'))]) : (scope.row.emailaccount == '' || scope.row.emailaccount == null) ? _c('el-button', {
          attrs: {
            "type": "primary",
            "size": "small",
            "disabled": scope.row.emailaccount == '' || scope.row.emailaccount == null
          },
          on: {
            "click": function($event) {
              return _vm.extension(scope.row)
            }
          }
        }, [_vm._v("无法推广")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "extensiontime",
      "label": "推广日期",
      "width": "160"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.isextension === '1') ? _c('span', [_vm._v(_vm._s(scope.row.extensiontime))]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "nickname",
      "label": "管理员姓名",
      "width": "110"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "emailaccount",
      "label": "管理员手机号",
      "width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "now_template_id",
      "label": "当前版本",
      "width": "110"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "是否最新版本",
      "width": "110"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(parseInt(scope.row.now_template_id) === parseInt(scope.row.latest_version)) ? _c('p', [_vm._v("是")]) : _c('p', [_vm._v("否")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "更新小程序",
      "width": "110"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "primary",
            "disabled": scope.row.disabled || scope.row.loading
          },
          on: {
            "click": function($event) {
              return _vm.handleUpdateMp(scope.row.id, scope.row)
            }
          }
        }, [_vm._v(_vm._s(scope.row.loading ? '提交中...' : '更新'))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "app_nick_name",
      "label": "小程序名称"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "isoriginalfactory",
      "label": "是否原厂"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "primary",
            "size": "small",
            "disabled": scope.row.isoriginalfactory !== '否'
          },
          on: {
            "click": function($event) {
              return _vm.confirm(scope.row)
            }
          }
        }, [_vm._v(_vm._s(scope.row.isoriginalfactory == "否" ? '待认证' : '已认证'))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "isoriginalfactory",
      "label": "禁止跳转到选型宝小程序"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "primary",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.jump(scope.row)
            }
          }
        }, [_vm._v(_vm._s(scope.row.is_jump === '1' ? '跳转' : '取消跳转'))])]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "table-list__footer"
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.currentPage.two,
      "page-size": _vm.page_size,
      "layout": "total, prev, pager, next, jumper",
      "total": _vm.totalTwo
    },
    on: {
      "current-change": _vm.handlePageChangeTwo
    }
  })], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "测试账号",
      "name": "2"
    }
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%",
      "margin-bottom": "20px"
    },
    attrs: {
      "data": _vm.testList,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "createtime",
      "label": "注册时间",
      "width": "170",
      "fixed": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "factory_qc_name",
      "label": "厂商名称",
      "width": "200",
      "fixed": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "factory_short_name",
      "label": "厂商简称",
      "width": "130"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "小程序二维码",
      "width": "150",
      "prop": "cs_qrcode_url"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-popover', {
          attrs: {
            "placement": "left-start",
            "width": "50px",
            "trigger": "click"
          }
        }, [_c('img', {
          attrs: {
            "src": scope.row.cs_qrcode_url == null ? scope.row.app_qrcode : scope.row.cs_qrcode_url,
            "alt": "",
            "width": "250px"
          }
        }), _vm._v(" "), _c('el-button', {
          attrs: {
            "slot": "reference",
            "type": "primary"
          },
          slot: "reference"
        }, [_vm._v("查看二维码")])], 1)]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "isoriginalfactory",
      "label": "是否推荐",
      "width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "primary",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.recommend(scope.row)
            }
          }
        }, [_vm._v(_vm._s(scope.row.isrecommend == 1 ? '取消推荐' : '推荐'))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "accountquality_status",
      "label": "账号质量",
      "width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-select', {
          attrs: {
            "placeholder": "请选择",
            "size": "mini"
          },
          on: {
            "change": function($event) {
              return _vm.handlequality(scope.row)
            }
          },
          model: {
            value: (scope.row.accountquality_status),
            callback: function($$v) {
              _vm.$set(scope.row, "accountquality_status", $$v)
            },
            expression: "scope.row.accountquality_status"
          }
        }, _vm._l((_vm.options), function(item) {
          return _c('el-option', {
            key: item.value,
            attrs: {
              "label": item.label,
              "value": item.value
            }
          })
        }), 1)]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "nickname",
      "label": "管理员姓名",
      "width": "110"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "emailaccount",
      "label": "管理员手机号",
      "width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "isExamine",
      "label": "是否提交微信审核",
      "width": "170"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "isExamineSuccess",
      "label": "微信审核是否通过",
      "width": "200"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "isPulish",
      "label": "是否发布小程序",
      "width": "130"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "app_nick_name",
      "label": "小程序名称",
      "width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "isoriginalfactory",
      "label": "是否原厂",
      "width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "primary",
            "size": "small",
            "disabled": scope.row.isoriginalfactory !== '否'
          },
          on: {
            "click": function($event) {
              return _vm.confirm(scope.row)
            }
          }
        }, [_vm._v(_vm._s(scope.row.isoriginalfactory == "否" ? '待认证' : '已认证'))])]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "table-list__footer"
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.currentPage.three,
      "page-size": _vm.page_size,
      "layout": "total, prev, pager, next, jumper",
      "total": _vm.totalThree
    },
    on: {
      "current-change": _vm.handlePageChangeThree
    }
  })], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "垃圾账号",
      "name": "3"
    }
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%",
      "margin-bottom": "20px"
    },
    attrs: {
      "data": _vm.rubblishList,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "createtime",
      "label": "注册时间",
      "width": "170",
      "fixed": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "factory_qc_name",
      "label": "厂商名称",
      "width": "200",
      "fixed": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "factory_short_name",
      "label": "厂商简称",
      "width": "130"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "小程序二维码",
      "width": "150",
      "prop": "cs_qrcode_url"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-popover', {
          attrs: {
            "placement": "left-start",
            "width": "50px",
            "trigger": "click"
          }
        }, [_c('img', {
          attrs: {
            "src": scope.row.cs_qrcode_url == null ? scope.row.app_qrcode : scope.row.cs_qrcode_url,
            "alt": "",
            "width": "250px"
          }
        }), _vm._v(" "), _c('el-button', {
          attrs: {
            "slot": "reference",
            "type": "primary"
          },
          slot: "reference"
        }, [_vm._v("查看二维码")])], 1)]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "isoriginalfactory",
      "label": "是否推荐",
      "width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "primary",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.recommend(scope.row)
            }
          }
        }, [_vm._v(_vm._s(scope.row.isrecommend == 1 ? '取消推荐' : '推荐'))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "accountquality_status",
      "label": "账号质量",
      "width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-select', {
          attrs: {
            "placeholder": "请选择",
            "size": "mini"
          },
          on: {
            "change": function($event) {
              return _vm.handlequality(scope.row)
            }
          },
          model: {
            value: (scope.row.accountquality_status),
            callback: function($$v) {
              _vm.$set(scope.row, "accountquality_status", $$v)
            },
            expression: "scope.row.accountquality_status"
          }
        }, _vm._l((_vm.options), function(item) {
          return _c('el-option', {
            key: item.value,
            attrs: {
              "label": item.label,
              "value": item.value
            }
          })
        }), 1)]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "nickname",
      "label": "管理员姓名",
      "width": "110"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "emailaccount",
      "label": "管理员手机号",
      "width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "isExamine",
      "label": "是否提交微信审核",
      "width": "170"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "isExamineSuccess",
      "label": "微信审核是否通过",
      "width": "200"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "isPulish",
      "label": "是否发布小程序",
      "width": "130"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "app_nick_name",
      "label": "小程序名称",
      "width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "isoriginalfactory",
      "label": "是否原厂",
      "width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "primary",
            "size": "small",
            "disabled": scope.row.isoriginalfactory !== '否'
          },
          on: {
            "click": function($event) {
              return _vm.confirm(scope.row)
            }
          }
        }, [_vm._v(_vm._s(scope.row.isoriginalfactory == "否" ? '待认证' : '已认证'))])]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "table-list__footer"
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.currentPage.four,
      "page-size": _vm.pageSize,
      "layout": "total, prev, pager, next, jumper",
      "total": _vm.totalFour
    },
    on: {
      "current-change": _vm.handlePageChangeFour
    }
  })], 1)], 1)], 1)], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@9.9.5@vue-loader/lib/template-compiler.js?id=data-v-7373a120!./~/_vue-loader@9.9.5@vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/enterprise/enterprise.vue
// module id = 468
// module chunks = 11